import React from 'react';
import { ksefOutgoingApi } from '../Api/ksefOutgoingApi';
import {
  mapInvoiceToKsefOutgoingLookup,
  type KsefOutgoingInvoiceLookup,
  type KsefOutgoingInvoiceLookupSource,
} from './invoiceLookupMapper';

const ksefOutgoingInvoiceLookupApi = ksefOutgoingApi.injectEndpoints({
  endpoints: (builder) => ({
    getKsefOutgoingInvoiceLookupRaw: builder.query<KsefOutgoingInvoiceLookupSource, number>({
      query: (invoiceId) => ({
        url: `/invoices/${invoiceId}`,
      }),
    }),
  }),
});

const { useGetKsefOutgoingInvoiceLookupRawQuery } = ksefOutgoingInvoiceLookupApi;

type InvoiceLookupQueryOptions = Parameters<typeof useGetKsefOutgoingInvoiceLookupRawQuery>[1];
type InvoiceLookupQueryResult = ReturnType<typeof useGetKsefOutgoingInvoiceLookupRawQuery>;

export type KsefOutgoingInvoiceLookupQueryResult = Pick<
  InvoiceLookupQueryResult,
  'isLoading' | 'isFetching' | 'isError' | 'error' | 'refetch'
> & {
  data?: KsefOutgoingInvoiceLookup;
};

export const useGetKsefOutgoingInvoiceLookupQuery = (
  invoiceId: number,
  options?: InvoiceLookupQueryOptions
): KsefOutgoingInvoiceLookupQueryResult => {
  const queryResult = useGetKsefOutgoingInvoiceLookupRawQuery(invoiceId, options);

  const data = React.useMemo(
    () => mapInvoiceToKsefOutgoingLookup(queryResult.data),
    [queryResult.data]
  );

  return {
    data,
    isLoading: queryResult.isLoading,
    isFetching: queryResult.isFetching,
    isError: queryResult.isError,
    error: queryResult.error,
    refetch: queryResult.refetch,
  };
};
